<template lang="html">
  <div id="informationPopup" :style="getStyle()" v-if="$store.state.isInfoPopupShown">
    <span>予約の情報</span>
    <button class="closeButton" @click="closePopup">x</button>

    <table id="tableTimes">
      <tr>
        <td><span>開始: </span></td>
        <td><input type="text" :value="$store.state.informationPopup.reservation.start_time" readonly />
        </td>
      </tr>
      <tr>
        <td><span>終了: </span></td>
        <td><input type="text" :value="$store.state.informationPopup.reservation.end_time" readonly />
        </td>
      </tr>
    </table>
    <label v-if="isTanki()">短期講座</label>

    <table id="tableNames">
      <tr>
        <td><span>生徒のお名前：</span></td>
        <td><input type="text" :value="$store.state.informationPopup.reservation.student.fullname" readonly /></td>
      </tr>
      <tr>
        <td><span>先生のお名前：</span></td>
        <td><input type="text" :value="$store.state.informationPopup.reservation.teacher.fullname" readonly /></td>
      </tr>
    </table>
    <div>
      <div id="reservationType">授業の種類<input type="text" :value="$store.state.informationPopup.reservation.reservation_type" readonly></div>
      <div id="hasTest">
        配布物: {{ $store.state.informationPopup.reservation.has_test ? '有り' : '無し'}}
      </div>
    </div>
    <div id="messageContainer">
      <div id="messageSubject">連絡事項</div>
      <textarea id="messageBody" readonly :rows="$store.state.informationPopup.reservation.message === '' ? 1 : 2"
      :value="$store.state.informationPopup.reservation.message"></textarea>
    </div>
    <div id="isOnline">
        授業形態: {{Number($store.state.informationPopup.reservation.online)===1 ? 'オンライン' : '対面'}}
      </div>
    <button v-if="isEditable()" @click="enterEdit">編集する</button>
    <div id="delete-block" v-if="!isEditable() && isFuture()">
      <span>※この時間は予約の削除のみ可能です</span>
      <button @click="enterDelete">予約を削除する</button>
      <el-dialog
        class="dialog"
        title="削除の確認"
        :visible.sync="dialogDeleteVisible"
        width="50%"
        :modal-append-to-body="false"
        top="20%">
        <p>この予約は月末まで毎週予約されています。</p>
        <p>以降の予約を全て削除しますか？この予約のみを削除しますか？</p>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="() => {
              isAllEditing=true
              dialogDeleteVisible=false
              doDelete()
            }">
            以降の予約全てを削除
          </el-button>
          <el-button type="primary"
          @click="() => {
            isAllEditing=false
            dialogDeleteVisible=false
            doDelete()
          }">
            この予約のみ削除
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  HIDE_INFORMATION_POPUP,
  RESERVATIONBOX_ENTER_EDIT,
  SPINNER_HIDE,
  SPINNER_SHOW
} from '@/vuex/mutation_types'
import T from '@/modules/time'
export default {
  data () {
    return {
      width: 400,
      isAllEditing: false,
      dialogDeleteVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'getLeftPosOfClassroom',
      'timelinesWidth',
      'timelineHeight',
      'timeToPosition',
      'getCurDateFormated'
    ])
  },
  methods: {
    ...mapActions([
      'deleteReservation',
      'deleteRecurrentReservations',
      'getReservations'
    ]),
    getStyle () {
      let style = {
        width: this.width + 'px'
      }
      let reservation = this.$store.state.informationPopup.reservation
      const targetBox = {
        width: this.$store.state.columnWidth,
        top: this.timeToPosition(
          new T(reservation.start_time).toString()
        ),
        bottom: this.timeToPosition(
          new T(reservation.end_time).toString()
        ),
        left: this.getLeftPosOfClassroom(
          reservation.classroom
        )
      }
      targetBox['height'] = targetBox.bottom - targetBox.top

      // editingBoxの位置によって位置を変更
      if (targetBox.left < this.timelinesWidth / 2) {
        // 左側半分にあるときは editingBox の右側に表示
        style.left = (targetBox.left + this.$store.state.columnWidth) + 'px'
        style.right = undefined
      } else {
        // 右半分にあるときは editingBox の左側
        style.left = (targetBox.left - this.width - 5) + 'px'
      }
      if (targetBox.top < this.timelineHeight / 2) {
        // 上半分にあるときは editingBox の上端に追従
        style.top = targetBox.top + 'px'
        style.bottom = undefined
      } else {
        // 下半分の時は、 previewBox の下端に追従
        style.top = (targetBox.top) + 'px'
      }
      return style
    },
    isTanki () {
      let st = this.$store.state.informationPopup.reservation.student.status
      return st === 'temporal' || st === 'trial' || st === 'temp/temp' || st === 'temp/norm'
      // return this.$store.state.informationPopup.reservation.student.user_name.startsWith('tanki')
    },
    closePopup () {
      this.$store.commit(HIDE_INFORMATION_POPUP)
    },
    enterEdit () {
      this.$store.commit(HIDE_INFORMATION_POPUP)
      this.$store.commit(RESERVATIONBOX_ENTER_EDIT,
          this.$store.state.informationPopup.reservation)
    },
    enterDelete () {
      this.eraseReservation()
    },
    doDelete () {
      this.$store.commit(SPINNER_SHOW)
      let recurrenceId = this.$store.state.informationPopup.reservation.recurrence_id
      if (!this.isAllEditing) {
        // 1つの予約のみ削除
        this.deleteReservation(this.$store.state.informationPopup.reservation.id)
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      } else {
        // 以降の予約を全て削除
        this.deleteRecurrentReservations({ id: recurrenceId, fromReservaitonId: this.$store.state.informationPopup.reservation.id })
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      }
      this.$store.commit(HIDE_INFORMATION_POPUP)
    },
    eraseReservation () {
      if (this.$store.state.informationPopup.reservation.recurrence_id !== null) {
        // 繰り返し予約の削除の場合は確認ダイアログを出す
        this.dialogDeleteVisible = true
      } else {
        let ret = confirm('削除します．よろしいですか？')
        if (ret) {
          this.doDelete()
        }
      }
    },
    isEditable () {
      let userType = this.$store.state.userInfo.user_type
      return userType !== 'student' &&
              (userType === 'admin' ||
              this.$store.state.informationPopup.reservation.teacher.id === this.$store.state.userInfo.user_id
            ) &&
            this.isFuture() &&
            this.isBeforeDeadline()
    },
    isFuture () {
      // 現在時刻が予約時刻よりも前かどうか
      let today = new Date()
      let date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])
      return today.getTime() < reservationDate.getTime() || this.$store.state.userInfo.user_type === 'admin'
    },
    isBeforeDeadline () {
      // 現在時刻が予約時刻の1日前(予約時刻が月曜日の場合は2日前)の22時以前かどうか
      // 管理者にはこの制限を設けない
      if (this.$store.state.userInfo.user_type === 'admin') {
        return true
      }
      let today = new Date()
      let date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])

      let dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) -
                        new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24
      return (reservationDate.getDay() === 1 && (dateDiff > 2 || (dateDiff === 2 && today.getHours() < 22))) ||   // 予約時刻が月曜日の場合
              (reservationDate.getDay() !== 1 && (dateDiff > 1 || (dateDiff === 1 && today.getHours() < 22)))     // 月曜日以外の場合
    }
  }
}
</script>

<style lang="css" scoped>
#informationPopup {
  position: absolute;

  font-size: 20px;
  margin: 0px 5px 0px;
  box-sizing: border-box;
  background-color: white;
  border-color: #0065B3;
  border-style: solid;
  border-radius: 5px;
  padding-top: 5px;
  z-index: 999;
}
#tableTimes, #tableNames {
  margin: 10px;
}

#reservationType,#hasTest {
  display: inline;
  width: 150px;
  margin: 10px;
}
#messageBody {
  width: 90%;
}
#reservationType>input {
  width:80px;
}
#delete-block {
  color: #ff6666;
}
#delete-block > button {
  color: #ff6666;
}
.closeButton {
  float: right;
  border: none;
  color: white;
  margin-right: 5px;
  background-color: #ffd500;
}
.closeButton:hover {
  opacity: 0.5;
}
label {
  display: block;
}


#messageContainer {
  width:100%;
  margin-top: 10px;
}
.dialog {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// InformationPopup.vue?fa284316